import React, { useState, useEffect } from "react";
import {
  Box,
  FormControl,
  Select,
  MenuItem,
  Chip,
  Typography,
  IconButton,
  Tooltip,
  OutlinedInput,
} from "@mui/material";
import FilterListIcon from "@mui/icons-material/FilterList";
import ClearIcon from "@mui/icons-material/Clear";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchLabels,
  clearLabelFilter,
  addToLabelFilter,
  removeFromLabelFilter,
} from "../../../redux/Slice/Contacts/labelsSlice";

const LabelsFilter = ({ onFilterChange }) => {
  const dispatch = useDispatch();
  const { labels, labelFilter } = useSelector((state) => state.labels);
  const [, ] = useState(false);

  useEffect(() => {
    dispatch(fetchLabels());
  }, [dispatch]);

  useEffect(() => {
    if (onFilterChange) {
      onFilterChange(labelFilter);
    }
  }, [labelFilter, onFilterChange]);


  const handleClearAll = () => {
    dispatch(clearLabelFilter());
  };

  const handleSelectChange = (event) => {
    const value = event.target.value;
    if (value && !labelFilter.includes(value)) {
      dispatch(addToLabelFilter(value));
    }
  };

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1, flexWrap: "wrap" }}>
      <Typography
        variant="body2"
        color="text.secondary"
        sx={{ fontSize: { xl: "1.0625rem" } }}
      >
        Filter by Labels:
      </Typography>
      
      <FormControl size="small" sx={{ minWidth: 150 }}>
        <Select
          value=""
          onChange={handleSelectChange}
          displayEmpty
          input={<OutlinedInput />}
          renderValue={() => (
            <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
              <FilterListIcon fontSize="small" />
              <Typography variant="body2">Add Filter</Typography>
            </Box>
          )}
        >
          {labels
            .filter((label) => !labelFilter.includes(label))
            .map((label) => (
              <MenuItem key={label} value={label}>
                {label}
              </MenuItem>
            ))}
        </Select>
      </FormControl>

      {labelFilter.length > 0 && (
        <>
          <Box sx={{ display: "flex", gap: 0.5, flexWrap: "wrap" }}>
            {labelFilter.map((label) => (
              <Chip
                key={label}
                label={label}
                size="small"
                onDelete={() => dispatch(removeFromLabelFilter(label))}
                color="primary"
                variant="outlined"
              />
            ))}
          </Box>
          
          <Tooltip title="Clear all filters">
            <IconButton size="small" onClick={handleClearAll}>
              <ClearIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </>
      )}

      {labelFilter.length === 0 && labels.length === 0 && (
        <Typography variant="body2" color="text.secondary" sx={{ fontStyle: "italic" }}>
          No labels available
        </Typography>
      )}
    </Box>
  );
};

export default LabelsFilter;
